import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import classnames from 'classnames';

import {MinimizeIcon} from '../../icon';
import styles from './minimize-button.module.css';

type Props = {
    size?: number;
    tooltip?: string;
    getRef?: (arg1?: HTMLButtonElement | null | undefined) => void;
    onClick: (e: React.SyntheticEvent) => void;
    isMaximizeButton?: boolean;
    variant?: 'dark' | 'medium' | 'light';
};

export class MinimizeButton extends React.PureComponent<Props> {
    static defaultProps = {
        size: 14,
        variant: 'dark',
    };

    componentDidMount() {
        ReactTooltip.rebuild();
    }

    componentWillUnmount() {
        ReactTooltip.hide();
    }

    render() {
        let tooltip = this.props.isMaximizeButton ? 'Enlarge' : 'Minimize';
        if (this.props.tooltip) {
            tooltip = this.props.tooltip;
        }

        const containerTypeStyles = this.props.isMaximizeButton
            ? styles['container--maximize']
            : styles['container--minimize'];

        let containerColorStyles;
        switch (this.props.variant) {
            case 'light':
                containerColorStyles = styles['container--light'];
                break;
            case 'medium':
                containerColorStyles = styles['container--medium'];
                break;
            case 'dark':
            default:
                containerColorStyles = styles['container'];
        }

        const styleName = classnames(containerTypeStyles, containerColorStyles);

        return (
            <button
                data-tip={tooltip}
                onClick={this.props.onClick}
                ref={this.props.getRef}
                className={styleName}
            >
                <MinimizeIcon size={this.props.size} />
            </button>
        );
    }
}
